import PropTypes from 'prop-types';

export default {
  policy_text: PropTypes.string,
  header: PropTypes.string,
};
